import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConferenceToolService } from '../../services/conference-tool.service';
import { ConfigService } from '../../services/config.service';

type PageType = 'details' | 'create';

@Component({
  selector: 'itpx-zoom-auth-landing',
  templateUrl: './zoom-auth-landing.component.html',
  styleUrls: ['./zoom-auth-landing.component.css']
})

export class ZoomAuthLandingComponent implements OnInit {
  private page: string;
  private eventId: string;
  private isInternal: boolean;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: ConferenceToolService,
    private configService: ConfigService
  ) { }

  ngOnInit() {
    const p = this.route.snapshot.queryParams['state'].split(',');
    this.page = (p[0] as PageType) || null;
    this.eventId = p[1];
    this.isInternal = p[2];

    const params = {
      code: this.route.snapshot.queryParams['code'],
      redirectUri: encodeURIComponent(this.configService.get('server').sahara + '/hw/admin/zoom-auth-landing')
    }

    this.service.saveTokenZoom(params)
      .map(body => body.data)
      .subscribe((data) => {
        if (data) {
          if (this.isInternal)
            this.router.navigate(['course-management', 'course-events', this.eventId, this.page], { queryParams: { zoomRedirect: true } });
          else
            this.router.navigate([
              'product-seller',
              'overview',
              'course-management-seller',
              'course-events',
              this.eventId, this.page], { queryParams: { zoomRedirect: true } });
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/zoom-auth-landing/zoom-auth-landing.component.ts